export const defaults = {
  pinCodeLength: 4,
  smsCodeLength: 6,
  partialListSizeWithButton: 5,
  partialListSizeWithScroll: 20,
  sizeOfBottomBar: 5,
  maxLoginLength: 16,
  newsPageSize: 8,
  locality: {
    id: 26,
    name: 'Екатеринбург',
    oktmo: '65701000001',
    geolocation: [56.838011, 60.597465],
  },
};
